import "../styles/CabActivity.scss"
import ActivitySlider from "./slider/activitySlider";
import { useState } from "react";
import ModalActivity from "./modal/modalActivity";

const CabActivity = ({username}: {username: string}) => {
    
    return (
        <div className="cab-activity__container">
            <div className="cab-activity">
                <div className="cab-activity__title">
                    <p>Выберите категорию для изучения активности бойца</p>
                </div>
                <ActivitySlider username={username}/>

                
            </div>
        </div> 
    );
}

export default CabActivity;
